module.exports = __webpack_public_path__ + "static/media/info_clear_3.f38d8484.jpg";